import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'

const ContractBtn = ({ btnType, link, icon, text }) => {
  return (
    <Button
      type={btnType}
      block={btnType === 'default' ? true : false}
      className={icon ? 'download-contract' : ''}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      {icon && (
        <DownloadOutlined
          className="show-on-desktop"
          style={{ fontSize: '24px' }}
        />
      )}
      {text}
    </Button>
  )
}

export default ContractBtn
